import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useIAPList } from '@/modules/iap/model/list';
import { convertChestRewardListToStrings, useMixins } from '@/modules/picword/map/model/mixins';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';
import { picwordService } from '@/services/picword';
import { watch } from 'vue';

export function usePicwordMapAdd() {
    const router = useAppRouter();

    const { iapOptions, fetchIapOptions } = useIAPList();
    const { v$, model, addChestReward, removeChestReward, clearChestForm, SelectableBooster } = useMixins();

    const actions = {
        create: useCrudActions().excuteAndNotify({
            validator: v$,
            request: () => {
                const chests = convertChestRewardListToStrings(model.chestRewardList);
                return picwordService.map.create(
                    model.id,
                    model.name,
                    model.packageId,
                    model.price,
                    chests.chestByStars,
                    chests.chestRewardCredits,
                    chests.chestRewardHearts,
                    chests.chestRewardBoosters
                );
            },
            onSuccess: () => router.push({ name: ROUTE_NAME_PICWORD.MAP.INDEX })
        }),
        addChestReward,
        removeChestReward,
        clearChestForm
    };

    watch(
        () => model.selectedIap,
        value => {
            iapOptions.value.forEach(item => {
                if (item.value == value) {
                    model.packageId = item.data.packageId;
                    model.price = item.data.price;
                }
            });
        }
    );

    return { model, v$, fetch, actions, iapOptions, fetchIapOptions, SelectableBooster };
}
